import { GlobalFilter } from '../../interfaces/offer-management';

export class FiltersState {
  availableValues: GlobalFilter = { operatorIds: [], rooms: [], airlines: [], flightFromTimes: [] };
  selectedValues: GlobalFilter = { operatorIds: [], rooms: [], airlines: [], flightFromTimes: [] };
}
